export default "__VITE_ASSET__2426badf__"